import React from "react";

import styles from "./search.module.scss";

type ResultsPlaceholderProps = {
	text?: string;
};

const ResultsPlaceholder = ({
	text = "No Records to Display",
}: ResultsPlaceholderProps) => {
	return <div className={styles.resultsPlaceholder}>{text}</div>;
};

export default ResultsPlaceholder;
